"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_SERVICE_SUBCATEGORY_REQUEST_TYPE = void 0;
exports.ITOP_SERVICE_SUBCATEGORY_REQUEST_TYPE = {
    INCIDENT: 'incident',
    SERVICE_REQUEST: 'service_request',
};
